module.exports = __webpack_public_path__ + "images/d7c888fc.png";